import React from 'react';
import i18n from 'i18n';
import { connect } from 'react-redux';
import ApplicationState from 'store/interfaces';
import Grid from '@material-ui/core/Grid';
import { Typography, makeStyles, useTheme } from '@material-ui/core';
import { PartnerDataGraphFields } from 'modules/dashboard/interfaces';
import AutoCard from 'components/AutoCard';

import { PeriodCountAccess } from 'modules/environments/interfaces';
import { setPartnerDataPeriodFilter } from 'modules/dashboard/actions';
import FilterSelector from 'components/FilterSelector';
import styles, { overrideCardGraph, overrideFilter } from './styles';
import SessionsHistoryPartnerGraphContent from './SessionsHistoryPartnerGraphContent';

interface Props {
  partnerDataGraphFields: PartnerDataGraphFields;
  intervalTime: any;
  dateFilter: boolean;
  setPartnerDataPeriodFilter: (prop: string) => void;
}

const SessionsHistoryPartnerCard = ({
  partnerDataGraphFields,
  intervalTime,
  dateFilter,
  setPartnerDataPeriodFilter,
}: Props) => {
  const useStyles = makeStyles(styles);
  const classes = useStyles({});
  const { breakpoints } = useTheme();

  const filterPeriodOptions = () => [
    {
      id: 'last-24-hours',
      label: i18n.t(
        `ENVIRONMENT_DASHBOARD.LAST_${PeriodCountAccess.LAST_24_HOURS.toUpperCase()}`
      ),
      onClick: () =>
        setPartnerDataPeriodFilter(PeriodCountAccess.LAST_24_HOURS),
    },
    {
      id: 'last-48-hours',
      label: i18n.t(
        `ENVIRONMENT_DASHBOARD.LAST_${PeriodCountAccess.LAST_48_HOURS.toUpperCase()}`
      ),
      onClick: () =>
        setPartnerDataPeriodFilter(PeriodCountAccess.LAST_48_HOURS),
    },
    {
      id: 'last-7-days',
      label: i18n.t(
        `ENVIRONMENT_DASHBOARD.LAST_${PeriodCountAccess.LAST_7_DAYS.toUpperCase()}`
      ),
      onClick: () => setPartnerDataPeriodFilter(PeriodCountAccess.LAST_7_DAYS),
    },
    {
      id: 'last-15-days',
      label: i18n.t(
        `ENVIRONMENT_DASHBOARD.LAST_${PeriodCountAccess.LAST_15_DAYS.toUpperCase()}`
      ),
      onClick: () => setPartnerDataPeriodFilter(PeriodCountAccess.LAST_15_DAYS),
    },
    {
      id: 'last-30-days',
      label: i18n.t(
        `ENVIRONMENT_DASHBOARD.LAST_${PeriodCountAccess.LAST_30_DAYS.toUpperCase()}`
      ),
      onClick: () => setPartnerDataPeriodFilter(PeriodCountAccess.LAST_30_DAYS),
    },
    {
      id: 'last-60-days',
      label: i18n.t(
        `ENVIRONMENT_DASHBOARD.LAST_${PeriodCountAccess.LAST_60_DAYS.toUpperCase()}`
      ),
      onClick: () => setPartnerDataPeriodFilter(PeriodCountAccess.LAST_60_DAYS),
    },
  ];

  return (
    <Grid
      item
      xs={6}
      justify="center"
      alignContent="center"
      className={classes.pageBody}
    >
      <Grid container spacing={2}>
        <Grid item xs={12} className={classes.graphCard}>
          <Grid container alignItems="center" justify="space-between">
            <Grid item>
              <Typography className={classes.titleCard}>
                {i18n.t('CLIENTS_PAGE.SESSION_HISTORY_KEY')}
                {':'}
              </Typography>
            </Grid>
            <Grid item>
              {dateFilter && (
                <FilterSelector
                  overrideClasses={overrideFilter}
                  options={filterPeriodOptions()}
                  currentValue={{
                    label: i18n.t(
                      `ENVIRONMENT_DASHBOARD.LAST_${intervalTime.toUpperCase()}`
                    ),
                    onClick: () => null,
                  }}
                />
              )}
            </Grid>
          </Grid>
          <AutoCard overrideClasses={overrideCardGraph(breakpoints)}>
            <Grid container className={classes.containerGraph}>
              <SessionsHistoryPartnerGraphContent
                partnerDataGraphFields={partnerDataGraphFields}
              />
            </Grid>
          </AutoCard>
        </Grid>
      </Grid>
    </Grid>
  );
};

const mapStateToProps = ({
  dashboard: { partnerDataGraphFields, periodFilterPartnerGraph },
}: ApplicationState) => ({
  partnerDataGraphFields,
  intervalTime: periodFilterPartnerGraph,
});

export default connect(mapStateToProps, {
  setPartnerDataPeriodFilter,
})(SessionsHistoryPartnerCard);
